import { NgModule } from '@angular/core';
import { ArticleStoreModule } from './store';

@NgModule({
  imports: [ArticleStoreModule],
})
export class ArticleDataAccessModule {}
